/**
 * @title dnsmi-helper.js: Sub-module of CCPA feature
 * @description This module provides validation of the DNSMI request form
 * @dependency
 */
 define(['address','addressVerification'], function(address,addressVerification) {
	let DNSMIHelper = {
		init: function(){
			// this is used to enable Your Privacy Choices functions if the feature toggle is on
			let isYPCFlowEnabled = $('#ypc-rights-page').find('[name=isYPCFlowEnabled]').val();
			DNSMIHelper.analytics();

			if (isYPCFlowEnabled) {
				// YPC init
				DNSMIHelper.ypcMembershipNumberLinkListener();
				DNSMIHelper.ypcLandingViewValidationRules();
				DNSMIHelper.memberFormValidationRules();
				DNSMIHelper.populateState();
				DNSMIHelper.validationRulesNonMember();
				DNSMIHelper.focusOnErrorSuccessMsg();
				// only allow 12 digits on the membership ID fields
				$('#hasMembershipForm').find('[name=membershipNumber],[name=cnfMembershipNumber]').unmask().mask('000000000000');

				// css class helper to make sure all fields display the labels correctly
				// used on input change and for autocomplete prepopulate after page load
				setTimeout(() => {
					$('div.outline').find('input').each((i, obj) => {
						DNSMIHelper.handleInputFieldLabelCSS($(obj));
					});
				 }, 500);
				$('div.outline').find('input').on('change', function() {
					DNSMIHelper.handleInputFieldLabelCSS($(this));
				});
			} else {
				$('#dnsmiRequestForm').find('.critical-notification').addClass('ccpa-critical-error').removeClass('critical-notification');
				$('#dnsmiRequestForm').find('[name=membershipNumber],[name=cnfMembershipNumber]').unmask().mask('000000000000');
				DNSMIHelper.membershipNumberLinkListener();
			}
		},

		validationRulesApplied : false,
		// Set of rules used for memberShip number
	    // This method should be ran once with initialization
		validationRules : function(form) {
			if(!DNSMIHelper.validationRulesApplied){
				$.validator.addMethod("minLength", function( value, element ) {
					let valid = true;

					if (value.length < 9){
						$('#dob_error').hide();
						return false;
					}

					return valid;
					
				}, '');
			}
		},

		validate : function(){
			let form = $('#dnsmiRequestForm');
			DNSMIHelper.validationRules(form);
			
			form.validate({
				rules: {
					membershipNumber: {required: true, minLength: true},
					cnfMembershipNumber: {required: true, equalTo: '#dnsmiRequestForm input[name="membershipNumber"]'},
					lastName: {required: true}
				},
				messages :{
					membershipNumber : {required:messages.ERR_MEMBERSHIP_NUMBER, minLength:messages.ERR_INVALID_MEMBERSHIP_NUMBER},
					cnfMembershipNumber : {required:messages.ERR_CONFIRM_MEMBERSHIP_NUMBER},
					lastName : {required: messages.ERR_LAST_NAME},
				},
				errorElement : 'div',
				errorPlacement : function(error,element){
					$(error).attr('aria-live','polite');
					$(error).addClass('dynamic-error');
	                var errordiv = '<span class="offscreen">Error: </span>';
					$(error).prepend(errordiv);
					error.insertAfter(element);
					$('#dnsmiRequestForm').find(":input.error:first").focus();
				}
			});
		},

		/** Hides the "Learn More" link after it's clicked and resets the focus */
		showRecaptchaDetails: function() {
			$('#ypc-recaptcha-learn-more-link').addClass('hide');
			$('#recaptcha-message-top').focus();
		},

		validateReCaptcha: function(grecaptcha){
			$('#dob_error').hide();
			DNSMIHelper.validate();
			if($('#dnsmiRequestForm').valid() && DNSMIHelper.isMembershipNumberValid()){
				grecaptcha.execute();
			}			
			
		},
		isMembershipNumberValid: function(){
			if ((/^(\d{9}|\d{10}|\d{11})$/.test($('#membershipNumber').val()))){
				$('#dob_error').removeClass('hide');
				$('#dob_error').show();
				return false;
			}
			return true;			
		},
		submitDNSMIForm: function(){
			$('#dnsmiRequestForm').submit();
		},
		submitYPCForm: function(){
			$('#ypcNonMemberForm').submit();
		},
		membershipNumberLinkListener: function() {
			$('#ccpa-membership-link-to-modal').on('click', function (e) {
				COSTCO.util.membershipDetailedEnquiry(e);
			});
			COSTCO.dialog.initializeReturnFocusListener();
		},

		ypcMembershipNumberLinkListener: function() {
			$('#ypc-membership-link-to-modal').on('click', function (e) {
				COSTCO.util.membershipDetailedEnquiry(e);
			});
			COSTCO.dialog.initializeReturnFocusListener();
		},

        ypcLandingViewValidationRules: function() {
            $.validator.addMethod('checkHasMembershipSelectEmpty', function( value, element ) {
				if ($('input[name=hasMembershipSelect]:checked').val() === undefined) {
					return false;
				}
				return true;
			});
        },

		memberFormValidationRules: function() {
			$.validator.addMethod("emails", function( value, element ) {
				return /^[a-zA-Z0-9\-_+]+([.][a-zA-Z0-9\-_+]+)*@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-_]+\.)+))([a-zA-Z]{2,10})$/.test(value.toLowerCase());
			});
			$.validator.addMethod("checkSpecialchar", function (value, element) {
				// YPC last name shouldn't have any non-alphanumeric characters and needs at least 1 letter
				return this.optional(element) || !COSTCO.util.LAST_NAME_FIELD_REGEX.test(value) && COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
			});	
			
		},

		showErrorLabel: function(errorElement, sourceElement) {
			let sourceElementName = $(sourceElement).attr('name');
			$(errorElement).attr('aria-live', 'polite');
			$(errorElement).attr('id', sourceElementName + 'Error');
			$(errorElement).attr('role', 'alert');
			$(errorElement).addClass('dynamic-error');

			let errorSpan = '<span class="offscreen">'+ messages.OFFSCREEN_ERROR + ' </span>';
			$(errorElement).prepend(errorSpan);
			
			if (sourceElement.is(':radio')) {
				$(errorElement).addClass('dynamic-error-radio');
				$(errorElement).appendTo( sourceElement.parents('.radio-fieldset') );
				
			} else {
				$(errorElement).addClass('dynamic-error-input');
				errorElement.insertAfter(sourceElement);
			}

			$('#ypcRequestForm').find(':input.error:first').focus();
		},

		validateYPCLandingForm: function() {
			$('#ypcRequestForm').validate({
				rules: {
					hasMembershipSelect: {checkHasMembershipSelectEmpty: true}
				},
				messages: {
					hasMembershipSelect: {checkHasMembershipSelectEmpty: messages.YPC_ERR_SELECT_AN_OPTION}
				},
				ignore: [],
				errorElement: 'div',
				errorPlacement: DNSMIHelper.showErrorLabel,
				onfocusout: function(element) {
					// save and reuse the aria-invalid attribute so it won't get overrun
					let ariaInvalidAttr = $(element).attr('aria-invalid');

					this.element(element);

					$(element).attr('aria-invalid', ariaInvalidAttr);
				},
				highlight: function(element, errorClass, validClass) {
					$(element).addClass(errorClass).removeClass(validClass);
				},
				unhighlight: function(element, errorClass, validClass) {
					$(element).removeClass(errorClass).addClass(validClass);
				},
				invalidHandler: COSTCO.util.invalid_handler
			});
			
		},

		validateMemberForm: function() {
			$('#hasMembershipForm').validate({
				rules: {
					membershipNumber : {
						required: true
					},
					cnfMembershipNumber: {
						required: true,
						equalTo: '#hasMembershipForm input[name="membershipNumber"]'
					},
					lastName: {
						required: true,
						checkSpecialchar:true
					},
					email: {
						required: true,
						emails: true
					},
					confirmEmail: {
						required: true,
						emails: true,
						equalTo: '#hasMembershipForm input[name="email"]'
					}
				},
				messages: {
					membershipNumber: {
						required: messages.ERR_YPC_MEMBERSHIP_NUMBER
					},
					cnfMembershipNumber: {
						required: messages.ERR_YPC_CONFIRM_MEMBERSHIP_NUMBER,
						equalTo: messages.ERR_YPC_CONFIRM_MEMBERSHIP_NUMBER_MISMATCH
					},
					lastName: {
						required: messages.ERR_YPC_LAST_NAME,
						checkSpecialchar: messages.ERR_YPC_INVALID_LNAME
					},
					email: {
						required: messages.ERR_YPC_EMAIL_ADDRESS,
						emails: messages.ERR_YPC_EMAIL_ADDRESS_INVALID,
					},
					confirmEmail: {
						required: messages.ERR_YPC_CONFIRM_EMAIL_ADDRESS,
						emails: messages.ERR_YPC_EMAIL_ADDRESS_INVALID,
						equalTo: messages.ERR_YPC_CONFIRM_EMAIL_MISMATCH
					}
				},
				ignore: [],
				errorElement: 'div',
				errorPlacement: DNSMIHelper.showErrorLabel,
				onfocusout: function(element) {
					// save and reuse the aria-invalid attribute so it won't get overrun
					let ariaInvalidAttr = $(element).attr('aria-invalid');

					this.element(element);

					$(element).attr('aria-invalid', ariaInvalidAttr);
				},
				highlight: function(element, errorClass, validClass) {
					$(element).addClass(errorClass).removeClass(validClass);
					$(element).attr('aria-describedby', element.name + 'Error');
					$(element).attr('aria-invalid', 'true');
				},
				unhighlight: function(element, errorClass, validClass) {
					$(element).removeClass(errorClass).addClass(validClass);
					$(element).removeAttr('aria-describedby');
					$(element).attr('aria-invalid', 'false');
				},
				invalidHandler: COSTCO.util.invalid_handler
			});
		},

		isMembershipInputValid: function() {
			if ($('#membershipNumber').val().length < 12) {
				let errorDiv = $('#membershipInvalidErrorDiv');
				errorDiv.removeClass('hide');
				errorDiv.show();
				return false;
			}

			return true;
		},

		submitMemberForm: function(grecaptcha) {
			$('#membershipInvalidErrorDiv').hide();
			DNSMIHelper.validateMemberForm();

			if ($('#hasMembershipForm').valid() && DNSMIHelper.isMembershipInputValid()) {
				grecaptcha.execute();
			}
        },

		continueToSelectedForm: function() {
			DNSMIHelper.validateYPCLandingForm();

			if ($('#ypcRequestForm').valid()) {
				let selectedVal = $('#ypcRequestForm').find('#hasMembershipSelectionSet input:checked').val();

				if (selectedVal === $('#hasMembershipYesInput').val()) {
					window.location.href = 'YPCMemberView';
				} else if (selectedVal === $('#hasMembershipNoInput').val()) {
					window.location.href = 'YPCNonMemberView';
				}
			}
		},
		validationRulesNonMember : function() {
			$.validator.addMethod("emails", function( value, element ) {
				return /^[a-zA-Z0-9\-_+]+([.][a-zA-Z0-9\-_+]+)*@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-_]+\.)+))([a-zA-Z]{2,10})$/.test(value.toLowerCase());
			});
			$.validator.addMethod("countryspecificpostalcodePassCountrySelectorModal", function( value, element) {
				return !COSTCO.CAddressForm.isUS({input: element})
						? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value))
						: this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value))
			});
			$.validator.addMethod("confirmEmails", function( value, element ) {
			    var email=$('#ypcNonMemberForm').find('[name=email]').val().trim().toLowerCase();
				return value.toLowerCase()==email;
			});
			$.validator.addMethod("checkSpecialchar", function (value, element) {
				// YPCNM last name shouldn't have any non-alphanumeric characters and needs at least 1 letter				
				return this.optional(element) || !COSTCO.util.LAST_NAME_FIELD_REGEX.test(value) && COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
			});			
		},
		focusOnErrorSuccessMsg: function() {
			$('.ypcSuccessErrorMessage').focus();
		},

		handleInputFieldLabelCSS: function(obj) {
			if (obj.val() !== '') {
				$('div.outline').find(`label[for=${obj.attr('id')}]`).addClass('active');
			} else {
				$('div.outline').find(`label[for=${obj.attr('id')}]`).removeClass('active');
			}
		},

		validateNonMember : function(){
			DNSMIHelper.validationRulesNonMember();
			let form = $('#ypcNonMemberForm');
			form.validate({
				rules: {					
					lastName: {required: true, checkSpecialchar:true},
					email :{required: true ,emails: true, maxlength:254},
					confirmEmail:{required: true ,maxlength:254,confirmEmails: true},
					streetAddress: {required: true,maxlength:30},
					postal:{required: true,countryspecificpostalcodePassCountrySelectorModal:true},

				},
				messages :{
					lastName : {required: messages.ERR_YPCNM_LAST_NAME,checkSpecialchar: messages.ERR_YPCNM_INVALID_LNAME},
					email : {required:messages.ERR_YPCNM_EMAIL_ADDRESS, emails:messages.ERR_YPCNM_EMAIL_ADDRESS_INVALID, maxlength: messages.ERR_YPCNM_EMAIL_ADDRESS_INVALID},
					confirmEmail : {required:messages.ERR_YPCNM_CONFIRM_EMAIL_ADDRESS, emails:messages.ERR_YPCNM_EMAIL_ADDRESS_INVALID, maxlength: messages.ERR_YPCNM_EMAIL_ADDRESS_INVALID,confirmEmails: messages.ERR_YPCNM_CONFIRM_EMAIL_MISMATCH},
					streetAddress : {required: messages.ERR_YPCNM_STREET_ADDRESS, maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE},
					postal : messages.ERR_YPCNM_ZIPCODE,
				},
				errorElement : 'div',
				errorPlacement: DNSMIHelper.showErrorLabelNonMember,
				invalidHandler: COSTCO.util.invalid_handler
			});
		},
		validateReCaptchaNonMember: function(grecaptcha){
				grecaptcha.execute();		},
		showErrorLabelNonMember: function(errorElement, sourceElement) {
				let sourceElementName = $(sourceElement).attr('name');
				$(errorElement).attr('aria-live', 'polite');
				$(errorElement).attr('id', sourceElementName + 'Error');
				$(errorElement).attr('role', 'alert');
				$(errorElement).addClass('dynamic-error');
		
				let errorSpan = '<span class="offscreen">'+ messages.OFFSCREEN_ERROR + ' </span>';
				$(errorElement).prepend(errorSpan);
		
				if (sourceElement.is(':radio')) {
					$(errorElement).addClass('dynamic-error-radio');
					$(errorElement).appendTo( sourceElement.parents('.radio-fieldset') );
		
				} else {
					$(errorElement).addClass('dynamic-error-input');
					errorElement.insertAfter(sourceElement);
				}
		
				$('#ypcNonMemberForm').find(':input.error:first').focus();
				$('#zipcodeDescription').addClass('hide');
				$('#ypcAddressDescArea').addClass('hide');
			},
		
		submitYPC: function () {
			DNSMIHelper.validateNonMember();
			if($('#ypcNonMemberForm').valid()){
				var addressObject = {};
				var addressArray = [];
				var _baseAddr = $("#ypcNonMemberForm");
	
				addressObject['id'] = '';
				addressObject['lName'] = _baseAddr.find('[name=lastName]').val();
				addressObject['country'] = _baseAddr.find('[name=country]').val();
				addressObject['line1'] = _baseAddr.find('[name=streetAddress]').val();
				addressObject['zip'] = _baseAddr.find('[name=postal]').val();
				addressObject['city'] = _baseAddr.find('[name=city]').val();
				addressObject['state'] = _baseAddr.find('[name=state]').val();
				addressObject['email'] = _baseAddr.find('[name=email]').val();
				addressObject['addressType'] = 'S';
	
				addressArray.push(addressObject);
	
				if (typeof addressOptions === 'undefined') {
					addressOptions = {};
				}
				addressOptions.successCallback = DNSMIHelper.addressVerifiedCallback;
	
				addressVerification.addressVerification(addressArray, type, true, addressOptions);
			}
		},
	    addressVerifiedCallback : function(addressObj, type, preventajaxhtml, addressOptions) {
			if (typeof addressObj !== 'undefined' && addressObj != null) {
				if (addressObj.Validated_Address[0].result == 'ADDRESS_SUGGESTION_AVAILABLE' ||
					addressObj.Validated_Address[0].result == 'ADDRESS_WRONG_NO_SUGGESTION' ||
					addressObj.Validated_Address[0].result == 'ADDRESS_CORRECT_NO_SUGGESTION') {
					if (addressVerification.isSuggestedSameAsEntered(addressObj)) {
						DNSMIHelper.submitYPCForm();
					}else{
						DNSMIHelper.showAddressVerificationModal(addressObj, preventajaxhtml, addressOptions);
					}
				} else {
					DNSMIHelper.submitYPCForm();
				}
			}
		},
		/**
		 * This function is used to display the address validation modal.
		 */
		showAddressVerificationModal: function(addressObj, preventhtmlajax, addressOptions) {
			let suggested = addressObj.Validated_Address[0];
			let entered = addressObj.Address[0];
			let result = suggested.result;
			let modalBody = addressVerification.buildAddressVerificationModal(entered, suggested, result);
			let primaryDisabled = (result === 'ADDRESS_WRONG_NO_SUGGESTION');
			$('.order-ajax').removeClass('ajax-busy');
			if (typeof addressOptions.primaryEventCallback === 'undefined') {
				addressOptions.primaryEventCallback = DNSMIHelper.validateReCaptchaNonMember;
			}
			address.baseModal('S', 'verify', {
				body: modalBody,
				primary_event: function() {
					addressOptions.primaryEventCallback(grecaptcha);
				},
				primaryDisabled: primaryDisabled,
			});
	    },
		
		addressVerification: function (addressArray, type, preventajaxhtml, addressOptions) {
		      $('.order-ajax').addClass('ajax-busy');
		      var _dataType = 'json';
		      var _data = {};
		      _data['formdata'] = encodeURIComponent(JSON.stringify(addressArray));
		      $.ajax({
		        url: '/AjaxAddressVerificationCmd',
		        type: 'POST',
		        dataType: _dataType,
		        data: _data,
		        timeout: 15000
		      }).done(function (addressObj) {
		        addressOptions.successCallback(addressObj, type, preventajaxhtml, addressOptions);
		      }).fail(function (addressObj) {
		        // Timeout or error sets verifiedAddress to inputted array
		        // Error Calling Verification Service
		        console.log('Verification Address : ' + JSON.stringify(addressObj));
		      }).always(function () {
		        $('.order-ajax').removeClass('ajax-busy');
		      });
		    },
		populateState : function(){
			var stateProvList = countries;
			var stateOptions = COSTCO.CAddressForm.getStateOptions(stateProvList,undefined,undefined);
			var countryOptions = COSTCO.CAddressForm.getCountryOptions(undefined);
			$('#ypcNonMemberForm').find('.stateprov-select').empty().append(stateOptions);
			$('#ypcNonMemberForm').find('[name=postal]').on('input', function(event){
				var value = $(this).val();
				let region = COSTCO.util.isUsOrCaZipCode();
				if($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4){
					COSTCO.CAddress.bingCityState(this,'[name=city]','[name=state]');
					$('.ccpa-state-city-address').removeClass('hide');
					$('#zipcodeDescription').removeClass('hide');
					$('#ypcZipCodeArea').removeClass('ypc-no-bottom-margin').addClass('ypc-bottom-margin');
					$('#ypcAddressDescArea').removeClass('hide');
				}
				if($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length){
					if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
						COSTCO.CAddress.geocodeApiCityState(this,'[name=city]', '[name=state]');
					}
					if (!region) {
						if ((value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim())) || (value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())))
						COSTCO.CAddress.geocodeApiCityState(this, '[name=city]', '[name=state]');
					}
					$('.ccpa-state-city-address').removeClass('hide');
					$('#zipcodeDescription').removeClass('hide');
					$('#ypcZipCodeArea').removeClass('ypc-no-bottom-margin').addClass('ypc-bottom-margin');
					$('#ypcAddressDescArea').removeClass('hide');
				}
			});
			$("#country-row").find('.country-select').append(countryOptions);
			var state = $('#ypcNonMemberForm').find('[name=savedState]').val();
			if(state != undefined && state != "" ){
				$('#ypcNonMemberForm').find('[name=state]').val(state);
			}
		},

		toggleAddress: function() {
			$('#ypcAddressToggle').addClass('hide');
			$('#ypcAddressLine2').removeClass('hide');
			$('#ypcAddressLine1').removeClass('ypc-no-bottom-margin').addClass('ypc-bottom-margin');
		},

		analytics: function() {
			let landingPage = $('#ypc-rights-page').find('[name=ypcRequestForm]').length;
			if(landingPage) {
				window.digitalData = window.digitalData || {};
				digitalData.pageName = "Your Privacy Choices | Initial View";
				digitalData.pageType = "Your Privacy Choices";
			}
			
			let ypcFormPage = $('#ypc-rights-page').find('[name=hasMembershipForm]').length;
			let ypcNonMemberForm = $('#ypc-rights-page').find('[name=ypcNonMemberForm]').length;
			if(ypcFormPage || ypcNonMemberForm){
				window.digitalData = window.digitalData || {};
				digitalData.pageName = "Your Privacy Choices | Form";
				digitalData.pageType = "Your Privacy Choices";
			}

			let successText = $('#ypc-rights-page').find('[name=successMsg]').length;
			let errorText = $('#ypc-rights-page').find('[name=errorMsg]').length;
			if (errorText) {
				window.digitalDataEvents = [];
				digitalDataEvents.push( { uimsg:"Privacy Choices Flow | System Down Error" } );
			} else if (successText){
				window.digitalData = window.digitalData || {};
				digitalData.pageName = "Your Privacy Choices | Success";
				digitalData.pageType = "Your Privacy Choices";
			}
		}
	};
	
	if (typeof window.COSTCO === 'undefined') {
		window.COSTCO = {};
	}
	$(document).ready(function() {
		if(COSTCO && COSTCO.Global && COSTCO.DNSMIHelper){
			COSTCO.Global.notify('DNSMIHelperLoaded');
		}		
	});
	window.COSTCO.DNSMIHelper = DNSMIHelper;
	return DNSMIHelper;
});



// WEBPACK FOOTER //
// ./js/ccpa/dnsmi-helper.js